import { DBRegistrationQuestionSettings } from '../types/working-model';
import { Post, Get, Put, Delete } from './helpers';

export const UpsertRegistrationQuestionSettings = async (registrationQuestionSettings: DBRegistrationQuestionSettings[], channel: number, token: string): Promise<any> => {
	return Put(`/v3/admin/events/registration-question-settings/${channel}`, token, { registrationQuestionSettings }, false, true)
		.then(async res => {
			return await res.json();
		});
};
